export const DRAG_HANDLE_SELECTOR = '[data-editor-block-ctrl-drag-handle]';
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export const DRAG_HANDLE_WIDTH = 12;
